import { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { auth } from '../services/auth.js';

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const info = await auth.getUserInfo();
    setUser(info);
    setLoading(false);
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const signIn = async (email, password) => {
    await auth.signIn({ email, password });
    await refresh();
  };
  const signOut = () => {
    auth.signOut();
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, loading, signIn, signOut, refresh }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
